import React, { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "../DealsAndOffers/dealsAndOffers.css";
import ListReseller from "../Reseller/listReseller";
import ListVrTransactionHistory from "../Reseller/listVrTransactionHistory";
import "./headerReseller.css";
import { Skeleton } from "antd";

const STORAGE_KEY = "reseller_header_tab";

const HeaderReseller = () => {
  const [selectedTable, setSelectedTable] = useState(
    localStorage.getItem(STORAGE_KEY) || "reseller_list"
  );
  const [loading, setLoading] = useState(false);


  const handleTableSelection = (table) => {
    if (table === selectedTable || loading) return;

    setLoading(true);
    setSelectedTable(table);
    localStorage.setItem(STORAGE_KEY, table);

    setTimeout(() => {
      setLoading(false);
    }, 400);
  };

  return (
    <MainLayout>
      <div className="dealsAndOffers-container">
        <div className={`bg-white border-10 padding-10 shadow-box ${loading ? "disabled-tabs" : ""}`}
          style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", marginBottom: "20px" }}>
          <div className="hover_panel">
            <h4
              className={selectedTable === "reseller_list" ? "clicked" : ""}
              onClick={() => handleTableSelection("reseller_list")}
            >
              Reseller List
            </h4>

            <h4
              className={selectedTable === "transaction_list" ? "clicked" : ""}
              onClick={() => handleTableSelection("transaction_list")}
            >
              Vr Transaction History
            </h4>
          </div>
        </div>

        {loading && (
          <div className="tab-loader">
            <Skeleton active paragraph={{ rows: 6 }} />
          </div>
        )}

        <div className={`fade-wrapper ${loading ? "hide" : ""}`}>
          <div style={{ display: selectedTable === "reseller_list" ? "block" : "none" }}>
            <ListReseller />
          </div>

          <div style={{ display: selectedTable === "transaction_list" ? "block" : "none" }}>
            <ListVrTransactionHistory />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default HeaderReseller;
